import { IMask } from 'react-imask';

// This fixes issue where numeric inputs show '0' for inputs with no value
// It is because Number('') === '0' and we use it as a mask, so...yea
// This issue is fixed with react-imask v7, but the update is extremely difficult
// (it fixes a few "bugs" that we actually rely on, ex. https://github.com/uNmAnNeR/imaskjs/issues/896)
// If updating to v7, you can remove this workaround and just use Number
// Github reference: https://github.com /uNmAnNeR/imaskjs/issues/432
export class NullableMaskedNumber extends IMask.MaskedNumber {
  // @ts-ignore
  override get typedValue() {
    // @ts-ignore
    return this.unmaskedValue !== '' ? super.typedValue : '';
  }
  // @ts-ignore
  override set typedValue(num) {
    // @ts-ignore
    super.typedValue = num;
  }
}
